import EvalPager from './src/main';

/* istanbul ignore next */
EvalPager.install = function(Vue) {
  Vue.component(EvalPager.name, EvalPager);
};

export default EvalPager;
